/* Approved 11 October 2026: selling amounts round down to whole pounds.
 * Supplier reference data and existing Ethnicraft prices remain unchanged. */
window.FultonsSellingPrice = window.FultonsSellingPrice || ((value, preserveEthnicraft = false) => {
  if (preserveEthnicraft || typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return value;
  return Math.floor(value + 1e-9);
});
(()=>{'use strict';
 const init=root=>{
  if(root.dataset.homeReady)return;root.dataset.homeReady='true';
  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.querySelectorAll('[data-home-carousel]').forEach(carousel=>{
   const rail=carousel.querySelector('.fh-rail'),controls=carousel.querySelector('.fh-rail-controls'),prev=controls.querySelector('[data-home-prev]'),next=controls.querySelector('[data-home-next]');
   const update=()=>{const max=rail.scrollWidth-rail.clientWidth;controls.hidden=max<2;prev.disabled=rail.scrollLeft<2;next.disabled=rail.scrollLeft>=max-2;};
   const move=direction=>{const first=rail.firstElementChild;if(!first)return;const step=first.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).columnGap||0);rail.scrollBy({left:direction*step,behavior:reduced()?'instant':'smooth'});};
   prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
   rail.addEventListener('keydown',e=>{if(e.target!==rail)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
   rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();
  });
  const currency=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:0,maximumFractionDigits:2});
  const active=true;
  const updatePrices=()=>{
   root.querySelectorAll('[data-home-price]').forEach(row=>{
    const rrp=Number(row.dataset.rrp);if(!(rrp>0))return;
    const sale=window.FultonsSellingPrice(active&&row.dataset.featured==='true'?Number(row.dataset.fallback):rrp*(active?.70:.75));
    const amount=row.querySelector('[data-home-amount]'),text=currency.format(sale);if(amount.textContent!==text)amount.textContent=text;
    row.classList.toggle('fh-price--offer',active);
   });
   root.querySelectorAll('[data-home-discount]').forEach(badge=>{badge.hidden=!active;});
   
  };
  document.addEventListener('fultons:natuzzi-campaign-change',updatePrices);document.addEventListener('visibilitychange',updatePrices);window.addEventListener('focus',updatePrices);updatePrices();
  root.querySelectorAll('.fh-rail img:not([data-fultons-hover-photo]),.fh-pieces img:not([data-fultons-hover-photo])').forEach(img=>{const hide=()=>{img.closest('a').hidden=true;window.dispatchEvent(new Event('resize'));};img.addEventListener('error',hide);if(img.complete&&!img.naturalWidth)hide();});
 };
 const boot=()=>document.querySelectorAll('[data-home-refresh]').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
 document.addEventListener('shopify:section:load',boot);
})();
